export default __webpack_public_path__ + "static/media/50-MexicoTourism.af47f646.jpg";